import { render, staticRenderFns } from "./__store_shelf_form.vue?vue&type=template&id=7f9a638b&scoped=true&"
import script from "./__store_shelf_form.vue?vue&type=script&lang=js&"
export * from "./__store_shelf_form.vue?vue&type=script&lang=js&"
import style0 from "./__store_shelf_form.vue?vue&type=style&index=0&id=7f9a638b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9a638b",
  null
  
)

export default component.exports